import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "semantic-ui-css/semantic.min.css";
import "./App.scss";
import Toast from "./components/common/Toast";
import { Dimmer, Loader } from "semantic-ui-react";
import { Provider, useDispatch, useSelector } from "react-redux";
import { store } from "./redux/store";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { es } from "date-fns/locale";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./redux/store";
import { MainContext } from "./context/MainContext";
import PrivateRoutes from "./routes/PrivateRoute";
import PublicRoutes from "./routes/PublicRoutes";
import { AuthTypes } from "./redux/actions/_types";

export default function AppWrapper() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  );
}

function App() {
  const { i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState();
  const [dataToast, setDataToast] = useState({
    active: false,
    message: "",
    type: "",
  });
  const token = localStorage.getItem("tokenLog");
  const { decoded } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  function message(message) {
    setDataToast({ active: true, type: "error", message });
  }

  useEffect(() => {
    var lang = localStorage.getItem("language");
    if (!lang) {
      lang = "es";
      localStorage.setItem("language", "es");
    }
    i18n.changeLanguage(lang);
  }, []);

  function checkToken() {
    let response = false;
    if (token) {
      if(decoded){        
        if (decoded.expirationTime) {
          const date = new Date(0);
          const tokenExpiration = date.setUTCSeconds(decoded.expirationTime);
          if (tokenExpiration.valueOf() <= new Date().valueOf()) {
            message("Tu sesión expiró.");
            localStorage.removeItem("tokenLog");
            dispatch({
              type: AuthTypes.LOGOUT,
            });
          } else {
            response = true;
          }
        }
      }
    }
    return response
  }

  return (
    <>
      <MainContext.Provider value={{ setDataToast, setIsLoading, isLoading }}>
        <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
          <BrowserRouter>
            {checkToken() ? (
              <PrivateRoutes />
            ) : (
              <PublicRoutes />
            )}
          </BrowserRouter>
          <Toast setDataToast={setDataToast} dataToast={dataToast} />
          {isLoading && (
            <Dimmer className="c-loader" active>
              <Loader content="Cargando..." />
            </Dimmer>
          )}
        </MuiPickersUtilsProvider>
      </MainContext.Provider>
    </>
  );
}
